// import { useDispatch } from "react-redux";
// import { Row, Col, Input } from "antd";
// import _ from "lodash";
// import { ReactComponent as PlusIcon } from "@assets/images/plus-with-bg.svg";
// import { useTypedSelector } from "@hooks";
// import { handleOfferModeller } from "@store/offers";
// import { calculatePercentageAmount, getCurrencyTotal, round } from "@utils";
// import { useEffect } from "react";
// import { useLocation } from "react-router-dom";
// import { useFetchOfferCurrencyRateQuery } from "@/services";
// import { formatNumberWithCommas } from "@/utils/formatNumberWithCommas";
// import { currenciesConverter, calculatePropose } from "@utils";

// const OfferBenefits = () => {
//   const dispatch = useDispatch();
//   const { search } = useLocation();
//   const isRevised = search === "?mode=revise";
//   const {
//     offerModeller: { offer_benefits, offer_lti, offer_sti, offer_fixed_cash },
//     currencyRate,
//     currencyName,
//     offer,
//     offer_annual,
//     currentCandidateCurrency,
//   } = useTypedSelector(state => state.offers);
//   // Stock-aware PROPOSED LTI total, aligned with LongTermIncentives.getLtiTotal()
//   const proposedLtiStockAware = (() => {
//     const base = Number(offer_lti?.proposed_total_lti) || 0;
//     const stock = Number((offer_lti as any)?.selected_stock_value) || 1;

//     // If other_ltis exist, replace any "unit === false" entries with amount = value * stock
//     const adjusted = (offer_lti?.other_ltis || [])
//       .filter((x: any) => !x?.is_current)
//       .reduce((sum: number, it: any) => {
//         const value = Number(it?.value) || 0;
//         if (!it?.unit && value) {
//           // proposed_total_lti likely included raw value; replace raw with stock*value
//           return sum - value + round(value * (stock || 1));
//         }
//         return sum;
//       }, base);

//     return round(adjusted || 0);
//   })();

//   // Proposed-only: sum all proposed (non-current) benefit lines
//   // const proposedBenefitsValueTotal = (offer_benefits?.bonuses || [])
//   //   .filter(b => !b?.is_current)
//   //   .reduce((sum, b) => sum + (Number(b?.value) || 0), 0);

//   const calculateBenefitValue = (benefit: any): number => {
//     const rawCte =
//       benefit?.benefit_value_or_cte ??
//       benefit?.value ??
//       benefit?.percentage ??
//       0;

//     const cte = Number(rawCte) || 0;
//     const calculationBasis = benefit?.calculation_basis;
//     console.log("kk", calculationBasis)

//     const annualBaseSalary =
//       Number(offer_fixed_cash?.proposed_annual_base) || 0;

//     const guaranteedCash =
//       Number(offer_fixed_cash?.proposed_total) || 0;

//     let calculatedBenefitValue = 0;

//     switch (calculationBasis) {
//       case "percent_basic":
//         calculatedBenefitValue = calculatePercentageAmount(
//           annualBaseSalary,
//           cte
//         );
//         break;

//       case "percent_guaranteed":
//       case "percent_actual":
//         calculatedBenefitValue = calculatePercentageAmount(
//           guaranteedCash,
//           cte
//         );
//         break;

//       case "multiple_of_weekly_basic":
//         calculatedBenefitValue = round(
//           (annualBaseSalary / 52) * cte
//         );
//         console.log(annualBaseSalary, cte, "hey")
//         break;

//       case "flat":
//       default:
//         calculatedBenefitValue = cte;
//         break;
//     }

//     console.group(
//       `[Benefit Calculation] ${benefit?.name || benefit?.id}`
//     );

//     console.log("Complete benefit:", benefit);
//     console.log("New benefit_value_or_cte:", benefit?.benefit_value_or_cte);
//     console.log("Legacy value:", benefit?.value);
//     console.log("Legacy percentage:", benefit?.percentage);
//     console.log("Final CTE used:", cte);
//     console.log("Calculation basis:", calculationBasis);
//     console.log("Annual base salary:", annualBaseSalary);
//     console.log("Guaranteed cash:", guaranteedCash);
//     console.log("Calculated benefit value:", calculatedBenefitValue);

//     console.groupEnd();

//     return calculatedBenefitValue;
//   };

//   const getBenefitTotalContribution = (benefit: any): number => {
//     const calculatedBenefitValue = calculateBenefitValue(benefit);

//     const rawBenefitLimit = benefit?.benefit_limit;

//     const hasValidBenefitLimit =
//       rawBenefitLimit !== null &&
//       rawBenefitLimit !== undefined &&
//       rawBenefitLimit !== "" &&
//       Number.isFinite(Number(rawBenefitLimit));

//     const benefitLimit = hasValidBenefitLimit
//       ? Number(rawBenefitLimit)
//       : null;

//     const totalContribution =
//       benefitLimit === null
//         ? calculatedBenefitValue
//         : Math.min(calculatedBenefitValue, benefitLimit);

//     console.group(
//       `[Benefit Limit] ${benefit?.name || benefit?.id}`
//     );

//     console.log("Calculated Benefit Value:", calculatedBenefitValue);
//     console.log("Raw Benefit Limit:", rawBenefitLimit);
//     console.log("Has Valid Benefit Limit:", hasValidBenefitLimit);
//     console.log("Normalized Benefit Limit:", benefitLimit);
//     console.log("Total Contribution:", totalContribution);

//     console.groupEnd();

//     return totalContribution;
//   };

//   const proposedBenefitsValueTotal = (offer_benefits?.bonuses || [])
//     .filter(
//       benefit =>
//         !benefit?.is_current &&
//         !benefit?.exclude_from_offer
//     )
//     .reduce(
//       (total, benefit) =>
//         total + calculateBenefitValue(benefit),
//       0
//     );

//   const proposedBenefitsRemunerationTotal =
//     (offer_benefits?.bonuses || [])
//       .filter(
//         benefit =>
//           !benefit?.is_current &&
//           !benefit?.exclude_from_offer
//       )
//       .reduce(
//         (total, benefit) =>
//           total + getBenefitTotalContribution(benefit),
//         0
//       );

//   const { company } = useTypedSelector(state => state.auth?.user!);
//   const { id: company_id } = company!;

//   const readOnly =
//     offer && offer?.status !== "DRAFTED" && !isRevised ? true : false;
//   const currencyCode = currencyName?.split("(")[1]?.replace(")", "") || "";

//   const { proposed_currency_total } = getCurrencyTotal(
//     offer_benefits,
//     currencyRate,
//     []
//   );
//   const { current_currency_total } = getCurrencyTotal(
//     offer_benefits,
//     currentCandidateCurrency,
//     []
//   );

//   const labelColSpan = currencyCode ? 10 : 12;
//   const currencyColSpan = currencyCode ? 7 : 12;

//   const addMoreLocally = (is_current: boolean) => {
//     const newCurrent = {
//       is_current,
//       value: null,
//       name: null,
//       id: +_.uniqueId(),
//       readonly: true,
//     };
//     dispatch(
//       handleOfferModeller({
//         key: "offer_benefits",
//         data: {
//           bonuses: [...offer_benefits.bonuses, newCurrent],
//         },
//       })
//     );
//   };

//   const handleChangeNewField = (
//     id: number,
//     value: number | string,
//     type: "name" | "benefit_value_or_cte"
//   ) => {
//     dispatch(
//       handleOfferModeller({
//         key: "offer_benefits",
//         data: {
//           bonuses: offer_benefits?.bonuses?.map(bonus =>
//             bonus?.id === id ? { ...bonus, [type]: value } : bonus
//           ) as any,
//         },
//       })
//     );
//   };

//   const handleChangeNewFieldForPurpose = (
//     id: number,
//     value: number | string,
//     type: "name" | "value",
//     calculation_basis?: string
//   ) => {
//     dispatch(
//       handleOfferModeller({
//         key: "offer_benefits",
//         data: {
//           bonuses: offer_benefits?.bonuses?.map(bonus =>
//             bonus?.id === id
//               ? { ...bonus, [type]: value, calculation_basis }
//               : bonus
//           ) as any,
//         },
//       })
//     );
//   };
//   const removeField = (id: number) => {
//     dispatch(
//       handleOfferModeller({
//         key: "offer_benefits",
//         data: {
//           bonuses: offer_benefits?.bonuses?.map(bonus =>
//             bonus?.id === id ? { ...bonus, readonly: false } : bonus
//           ) as any,
//         },
//       })
//     );
//   };

//   const removeBonus = (id: number) => {
//     dispatch(
//       handleOfferModeller({
//         key: "offer_benefits",
//         data: {
//           bonuses: offer_benefits?.bonuses?.filter(
//             bonus => bonus?.id !== id
//           ) as any,
//         },
//       })
//     );
//   };

//   // const proposedTotal =
//   //   (offer_fixed_cash?.proposed_total || 0) +
//   //   (offer_sti?.proposed_total_bonus || 0) +
//   //   (offer_lti?.proposed_total_lti || 0) +
//   //   (offer_benefits?.proposed_total_bonus || 0);
//   const proposedTotal =
//     (offer_fixed_cash?.proposed_total || 0) +
//     (offer_sti?.proposed_total_bonus || 0) +
//     proposedLtiStockAware +
//     proposedBenefitsValueTotal; // ← use computed proposed benefits

//   const currentTotal =
//     (offer_fixed_cash?.current_total || 0) +
//     (offer_sti?.current_bonus_target || 0) +
//     (offer_lti?.current_total_lti || 0) +
//     (offer_benefits?.current_total_bonus || 0);

//   let percentageDifference = 0;

//   if (proposedTotal > 0 && currentTotal > 0) {
//     percentageDifference = (proposedTotal / currentTotal - 1) * 100;
//   }

//   const finalPercentage =
//     percentageDifference > 0 ? percentageDifference.toFixed(0) : 0;

//   let totalBenefitProposed = (proposedBenefits: number) => {
//     const result =
//       offer_sti?.is_sale_incentive &&
//         offer_fixed_cash?.proposed_annual_base &&
//         offer_sti?.proposed_base_pay_percentage
//         ? round(
//           (offer_fixed_cash.proposed_annual_base *
//             ((offer_fixed_cash.proposed_annual_base *
//               (100 - offer_sti.proposed_base_pay_percentage)) /
//               100)) /
//           ((offer_fixed_cash.proposed_annual_base *
//             offer_sti.proposed_base_pay_percentage) /
//             100) -
//           offer_sti.proposed_base_pay_percentage
//         ) +
//         ((offer_sti?.proposed_total_bonus || 0) +
//           (offer_fixed_cash?.proposed_total || 0))
//         : (offer_sti?.proposed_total_bonus || 0) +
//         (offer_fixed_cash?.proposed_total || 0);

//     // ⬇️ Use stock-aware LTI here
//     return result + proposedBenefits + proposedLtiStockAware || 0;
//   };

//   let totalBenefitCurrent = proposedTotal => {
//     var result =
//       offer_fixed_cash?.current_total + offer_sti?.current_total_bonus;
//     return result + proposedTotal + offer_lti?.current_total_lti || 0;
//   };

//   const {
//     data: counrtyList,
//     error,
//     isLoading,
//     isFetching,
//     isSuccess,
//     isError,
//     refetch,
//   } = useFetchOfferCurrencyRateQuery(
//     {
//       code: offer?.offer_candidate_detail?.currency?.id,
//       company_id,
//       offer_id: offer?.id,
//     },
//     {
//       refetchOnMountOrArgChange: true,
//       skip: !offer?.offer_candidate_detail?.currency?.id,
//     }
//   );
//   const currentOne = offer_benefits?.current_total_bonus;
//   const proposedOne = proposedBenefitsValueTotal;
//   const currencyDiffOne = currenciesConverter(
//     counrtyList?.data?.result || 1,
//     proposedOne
//   );
//   const differenceOne = calculatePropose(currentOne, currencyDiffOne);

//   //     offer_benefits?.current_total_bonus
//   // proposedBenefitsValueTotal
//   const currentTwo = totalBenefitCurrent(offer_benefits?.current_total_bonus);
//   const proposedTwo = Math.round(totalBenefitProposed(proposedBenefitsValueTotal));
//   const currencyDiffTwo = currenciesConverter(
//     counrtyList?.data?.result || 1,
//     proposedTwo
//   );
//   const differenceTwo = calculatePropose(currentTwo, currencyDiffTwo);

//   useEffect(() => {
//     handleChangeNewField("value_curr", +32, "null");
//   }, []);

//   return (
//     <>
//       <Row className="salary-offer">
//         <Col className="salary-offer__parent-col" span={12}>
//           <Row className="salary-offer__header-row cursor-pointer rounded-l-md  bg-revampLightBlueBackground">
//             <Col span={12}>
//               <div className="sub-heading font-semibold text-lg">Current</div>
//             </Col>
//           </Row>

//           <Row className="salary-offer__content-row salary-offer__content-row--last mt-5">
//             {/* Current-Cols */}
//             <Col className="salary-offer__content-row__col" span={labelColSpan}>
//               <div className="salary-offer__content-row__field-upper"></div>
//               {offer_benefits?.bonuses
//                 ?.filter(({ is_current }) => is_current)
//                 ?.map(({ name, id, readonly }) => (
//                   <div
//                     key={id}
//                     className={` ${offer_annual
//                       ? "salary-offer__content-row__field"
//                       : "salary-offer__content-row__field_extra"
//                       } `}
//                   >
//                     {name?.length && !readonly! ? (
//                       <label>{name}</label>
//                     ) : (
//                       <Input
//                         readOnly={readOnly}
//                         autoFocus
//                         onChange={e =>
//                           handleChangeNewField(id!, e?.target?.value, "name")
//                         }
//                         onKeyDown={e => {
//                           if (e.key === "Enter") {
//                             removeField(id!);
//                           }
//                         }}
//                         value={name || ""}
//                         placeholder="Value here..."
//                         size="large"
//                       />
//                     )}
//                     {!readOnly && (
//                       <div
//                         className="salary-offer__content-row__field__remove"
//                         onClick={() => removeBonus(id!)}
//                       >
//                         <PlusIcon fill="#000" />
//                       </div>
//                     )}
//                   </div>
//                 ))}
//               {!readOnly ? (
//                 <div
//                   onClick={() => addMoreLocally(true)}
//                   className="salary-offer__content-row__field--add-more"
//                 >
//                   <PlusIcon fill="#FF9560" />
//                   <span>Add more</span>
//                 </div>
//               ) : (
//                 <div className="salary-offer__content-row__field--add-more" />
//               )}
//             </Col>
//             <Col
//               className="salary-offer__content-row__col"
//               span={currencyColSpan}
//             >
//               <div className="salary-offer__content-row__field-upper">
//                 {offer?.offer_candidate_detail?.currency?.code}
//               </div>
//               {offer_benefits?.bonuses
//                 ?.filter(({ is_current }) => is_current)
//                 ?.map(({ name, value, id }) => (
//                   <div
//                     key={id}
//                     className={` ${offer_annual
//                       ? "salary-offer__content-row__field"
//                       : "salary-offer__content-row__field_extra"
//                       } `}
//                   >
//                     <div className={`w-full ${!offer_annual && "mt-4"}`}>
//                       <Input
//                         readOnly={readOnly}
//                         name={name!}
//                         type="text"
//                         value={formatNumberWithCommas(value || "")}
//                         onChange={e =>
//                           handleChangeNewField(
//                             id!,
//                             +e.target.value.replace(/,/g, ""),
//                             "value"
//                           )
//                         }
//                         type="text"
//                         placeholder="Value here..."
//                         size="large"
//                       />

//                       {!offer_annual && (
//                         <p className="pl-1">
//                           Monthly:{" "}
//                           {formatNumberWithCommas(
//                             round(value ? value / 12 : 0)
//                           )}
//                         </p>
//                       )}
//                     </div>
//                   </div>
//                 ))}
//             </Col>
//             {currencyCode ? (
//               <Col className="salary-offer__content-row__col" span={7}>
//                 <div className="salary-offer__content-row__field-upper">
//                   {currencyCode}
//                 </div>
//                 {offer_benefits?.bonuses
//                   ?.filter(({ is_current }) => is_current)
//                   ?.map(({ id, value }) => (
//                     <div
//                       key={id}
//                       className={` ${offer_annual
//                         ? "salary-offer__content-row__field"
//                         : "salary-offer__content-row__field_extra"
//                         } `}
//                     >
//                       <div className={`w-full ${!offer_annual && "mt-4"}`}>
//                         <Input
//                           value={formatNumberWithCommas(
//                             round(value! * currentCandidateCurrency!) || ""
//                           )}
//                           readOnly
//                           placeholder="Value here..."
//                           size="large"
//                           type="text"
//                         />

//                         {!offer_annual && (
//                           <p className="pl-1">
//                             Monthly:{" "}
//                             {formatNumberWithCommas(
//                               round(
//                                 round(value! * currentCandidateCurrency!)
//                                   ? round(value! * currentCandidateCurrency!) /
//                                   12
//                                   : 0
//                               )
//                             )}
//                           </p>
//                         )}
//                       </div>
//                     </div>
//                   ))}
//               </Col>
//             ) : null}
//           </Row>
//         </Col>
//         <Col className="salary-offer__parent-col" span={12}>
//           <Row className="salary-offer__header-row cursor-pointer rounded-r-md bg-revampLightBlueBackground">
//             <Col span={12}>
//               <div className="sub-heading font-semibold text-lg">Proposed</div>
//             </Col>
//           </Row>
//           <Row className="salary-offer__content-row salary-offer__content-row--last mt-5">
//             {/* Proposed-Cols */}

//             <Col className="salary-offer__content-row__col" span={labelColSpan}>
//               <div className="salary-offer__content-row__field-upper"></div>

//               {offer_benefits?.bonuses
//                 ?.filter(({ is_current }) => !is_current)
//                 ?.map(
//                   ({
//                     name,
//                     id,
//                     readonly,
//                     benefit_entitlement,
//                   }) => (
//                     <div key={id}>
//                       <div
//                         className={`${offer_annual
//                           ? "salary-offer__content-row__field"
//                           : "salary-offer__content-row__field_extra"
//                           }`}
//                       >
//                         {name?.length && !readonly ? (
//                           <label>{name}</label>
//                         ) : (
//                           <Input
//                             readOnly={readOnly}
//                             autoFocus
//                             onChange={e =>
//                               handleChangeNewField(
//                                 id!,
//                                 e.target.value,
//                                 "name"
//                               )
//                             }
//                             onKeyDown={e => {
//                               if (e.key === "Enter") {
//                                 removeField(id!);
//                               }
//                             }}
//                             value={name || ""}
//                             placeholder="Value here..."
//                             size="large"
//                           />
//                         )}

//                         {!readOnly && (
//                           <div
//                             className="salary-offer__content-row__field__remove"
//                             onClick={() => removeBonus(id!)}
//                           >
//                             <PlusIcon fill="#000" />
//                           </div>
//                         )}
//                       </div>

//                       {benefit_entitlement && (
//                         <div
//                           style={{
//                             marginTop: "-20px",
//                             marginBottom: "12px",
//                             paddingLeft: "25px",
//                             paddingRight: "40px",
//                             fontSize: "11px",
//                             color: "#6B7280",
//                           }}
//                         >
//                           {benefit_entitlement}
//                         </div>
//                       )}
//                     </div>
//                   )
//                 )}

//               {!readOnly ? (
//                 <div
//                   onClick={() => addMoreLocally(false)}
//                   className="salary-offer__content-row__field--add-more"
//                 >
//                   <PlusIcon fill="#FF9560" />
//                   <span>Add more</span>
//                 </div>
//               ) : (
//                 <div className="salary-offer__content-row__field--add-more" />
//               )}


//             </Col>
//             <Col
//               className="salary-offer__content-row__col"
//               span={currencyColSpan}
//             >
//               <div className="salary-offer__content-row__field-upper">
//                 {offer?.offer_position_detail?.currency?.code}
//               </div>

//               {offer_benefits?.bonuses
//                 ?.filter(({ is_current }) => !is_current)
//                 ?.map((benefit: any) => {
//                   const {
//                     id,
//                     name,
//                     calculation_basis,
//                     benefit_value_or_cte,
//                   } = benefit;

//                   const calculatedBenefitValue = calculateBenefitValue(benefit);
//                   const totalContribution = getBenefitTotalContribution(benefit);

//                   console.log("[Benefit UI Display]", {
//                     id: benefit?.id,
//                     name: benefit?.name,
//                     calculationBasis: benefit?.calculation_basis,
//                     benefitValueOrCte: benefit?.benefit_value_or_cte,
//                     calculatedBenefitValue,
//                     benefitLimit: benefit?.benefit_limit,
//                     totalContribution,
//                   });

//                   return (
//                     <div
//                       key={id}
//                       className={`${offer_annual
//                         ? "salary-offer__content-row__field"
//                         : "salary-offer__content-row__field_extra"
//                         }`}
//                     >
//                       <div className={`w-full ${!offer_annual ? "mt-4" : ""}`}>
//                         <Input
//                           readOnly={
//                             readOnly ||
//                             calculation_basis === "percent_guaranteed" ||
//                             calculation_basis === "percent_actual" ||
//                             calculation_basis === "percent_basic" ||
//                             calculation_basis === "multiple_of_weekly_basic"
//                           }
//                           name={name}
//                           type="text"
//                           value={formatNumberWithCommas(calculatedBenefitValue || "")}
//                           onChange={e =>
//                             handleChangeNewField(
//                               id,
//                               Number(e.target.value.replace(/,/g, "")),
//                               "benefit_value_or_cte"
//                             )
//                           }
//                           placeholder="Value here..."
//                           size="large"
//                         />

//                         {!offer_annual && (
//                           <p className="pl-1">
//                             Monthly:{" "}
//                             {formatNumberWithCommas(
//                               round(calculatedBenefitValue / 12)
//                             )}
//                           </p>
//                         )}
//                       </div>
//                     </div>
//                   );
//                 })}
//             </Col>
//             {currencyCode ? (
//               <Col className="salary-offer__content-row__col" span={7}>
//                 <div className="salary-offer__content-row__field-upper">
//                   {currencyCode}
//                 </div>
//                 {offer_benefits?.bonuses
//                   ?.filter(({ is_current }) => !is_current)
//                   ?.map((benefit: any) => {
//                     const calculatedBenefitValue = calculateBenefitValue(benefit);

//                     return (
//                       <div
//                         key={benefit.id}
//                         className={`${offer_annual
//                           ? "salary-offer__content-row__field"
//                           : "salary-offer__content-row__field_extra"
//                           }`}
//                       >
//                         <div className={`w-full ${!offer_annual ? "mt-4" : ""}`}>
//                           <Input
//                             value={formatNumberWithCommas(
//                               round(calculatedBenefitValue * (currencyRate || 1)) || ""
//                             )}
//                             readOnly
//                             placeholder="Value here..."
//                             size="large"
//                             type="text"
//                           />

//                           {!offer_annual && (
//                             <p className="pl-1">
//                               Monthly:{" "}
//                               {formatNumberWithCommas(
//                                 round(
//                                   (calculatedBenefitValue * (currencyRate || 1)) / 12
//                                 )
//                               )}
//                             </p>
//                           )}
//                         </div>
//                       </div>
//                     );
//                   })}
//               </Col>
//             ) : null}
//           </Row>
//         </Col>
//       </Row>

//       <Row className="salary-offer bg-revampLightBlueBackground rounded-md ">
//         <Col className="salary-offer__parent-col" span={12}>
//           <Row className="salary-offer__content-row salary-offer__content-row--last">
//             {/* Current-Cols */}
//             <Col className="salary-offer__content-row__col" span={labelColSpan}>
//               <div
//                 className={`${offer_annual
//                   ? "salary-offer__content-row__field  salary-offer__content-row__field--total"
//                   : "salary-offer__content-row__field_extra  salary-offer__content-row__field--total"
//                   } `}
//               >
//                 <label>Total Benefits</label>
//               </div>
//             </Col>

//             <Col
//               className="salary-offer__content-row__col"
//               span={currencyColSpan}
//             >
//               <div
//                 className={` ${offer_annual
//                   ? "salary-offer__content-row__field  salary-offer__content-row__field--total"
//                   : "salary-offer__content-row__field_extra  salary-offer__content-row__field--total"
//                   } `}
//               >
//                 <div className="w-full">
//                   <Input
//                     readOnly
//                     value={formatNumberWithCommas(
//                       offer_benefits?.current_total_bonus || ""
//                     )}
//                     name="current_total_lti"
//                     placeholder="Value here..."
//                     size="large"
//                     type="text"
//                   />

//                   {!offer_annual && (
//                     <p className="pl-1">
//                       Monthly:{" "}
//                       {formatNumberWithCommas(
//                         round(
//                           offer_benefits?.current_total_bonus
//                             ? offer_benefits?.current_total_bonus / 12
//                             : 0
//                         )
//                       )}
//                     </p>
//                   )}
//                 </div>
//               </div>
//             </Col>

//             {currencyCode ? (
//               <Col className="salary-offer__content-row__col" span={7}>
//                 <div
//                   className={` ${offer_annual
//                     ? "salary-offer__content-row__field  salary-offer__content-row__field--total"
//                     : "salary-offer__content-row__field_extra  salary-offer__content-row__field--total"
//                     } `}
//                 >
//                   <div className="w-full">
//                     <Input
//                       value={formatNumberWithCommas(
//                         current_currency_total || ""
//                       )}
//                       readOnly
//                       type="text"
//                       placeholder="Value here..."
//                       size="large"
//                     />

//                     {!offer_annual && (
//                       <p className="pl-1">
//                         Monthly:{" "}
//                         {formatNumberWithCommas(
//                           round(
//                             current_currency_total
//                               ? current_currency_total / 12
//                               : 0
//                           )
//                         )}
//                       </p>
//                     )}
//                   </div>
//                 </div>
//               </Col>
//             ) : null}
//           </Row>
//         </Col>
//         <Col className="salary-offer__parent-col" span={12}>
//           <Row className="salary-offer__content-row salary-offer__content-row--last">
//             {/* Current-Cols */}
//             <Col className="salary-offer__content-row__col " span={labelColSpan}>
//               <div
//                 className={`${offer_annual
//                   ? "salary-offer__content-row__field  salary-offer__content-row__field--total"
//                   : "salary-offer__content-row__field_extra  salary-offer__content-row__field--total"
//                   } `}
//               >
//                 <label>Total Benefits</label>
//               </div>
//             </Col>

//             <Col
//               className="salary-offer__content-row__col"
//               span={currencyColSpan}
//             >
//               <div
//                 className={` ${offer_annual
//                   ? "salary-offer__content-row__field  salary-offer__content-row__field--total"
//                   : "salary-offer__content-row__field_extra  salary-offer__content-row__field--total"
//                   } `}
//               >
//                 <div className="w-full">
//                   <Input
//                     readOnly
//                     type="text"
//                     name="proposed_total_lti"
//                     value={formatNumberWithCommas(proposedBenefitsValueTotal || "")}
//                     placeholder="Value here..."
//                     size="large"
//                   />

//                   {!offer_annual && (
//                     <p className="pl-1">
//                       Monthly:{" "}
//                       {formatNumberWithCommas(
//                         round(
//                           proposedBenefitsValueTotal ? proposedBenefitsValueTotal / 12 : 0
//                         )
//                       )}
//                     </p>
//                   )}
//                 </div>
//               </div>
//             </Col>

//             {currencyCode ? (
//               <Col className="salary-offer__content-row__col" span={7}>
//                 <div
//                   className={` ${offer_annual
//                     ? "salary-offer__content-row__field  salary-offer__content-row__field--total"
//                     : "salary-offer__content-row__field_extra  salary-offer__content-row__field--total"
//                     } `}
//                 >
//                   <div className="w-full">
//                     <Input
//                       value={formatNumberWithCommas(
//                         proposed_currency_total || ""
//                       )}
//                       readOnly
//                       placeholder="Value here..."
//                       size="large"
//                       type="text"
//                     />

//                     {!offer_annual && (
//                       <p className="pl-1">
//                         Monthly:{" "}
//                         {formatNumberWithCommas(
//                           round(
//                             proposed_currency_total
//                               ? proposed_currency_total / 12
//                               : 0
//                           )
//                         )}
//                       </p>
//                     )}
//                   </div>
//                 </div>
//               </Col>
//             ) : null}
//           </Row>
//         </Col>
//       </Row>

//       <Row className="salary-offer">
//         <Col className="salary-offer__parent-col" span={12}>
//           <Row className="salary-offer__content-row salary-offer__content-row--last">
//             {/* Current-Cols */}
//             <Col className="salary-offer__content-row__col" span={labelColSpan}>
//               <div className="salary-offer__content-row__field salary-offer__content-row__field--total"></div>
//             </Col>

//             <Col
//               className="salary-offer__content-row__col"
//               span={currencyCode ? 14 : currencyColSpan}
//             >
//               <div className="salary-offer__content-row__field salary-offer__content-row__field--total"></div>
//             </Col>
//           </Row>
//         </Col>
//         <Col className="salary-offer__parent-col" span={12}>
//           <Row className="salary-offer__content-row salary-offer__content-row--last">
//             {/* Current-Cols */}
//             <Col className="salary-offer__content-row__col" span={labelColSpan}>
//               <div className="salary-offer__content-row__field salary-offer__content-row__field--total">
//                 <label>Total Benefits Difference</label>
//               </div>
//             </Col>

//             <Col
//               className="salary-offer__content-row__col"
//               span={currencyCode ? 14 : currencyColSpan}
//             >
//               <div className="salary-offer__content-row__field salary-offer__content-row__field--total">
//                 <div
//                   className={`w-full px-6   text-white shadow-md my-2 font-semibold text-center text-sm outline-none border border-themeInputBorder bg-revampBlue  py-2 rounded-md`}
//                 >
//                   {`${differenceOne?.toFixed(2)}%`}
//                 </div>
//               </div>
//             </Col>
//           </Row>
//         </Col>
//       </Row>

//       <Row className="salary-offer bg-revampLightBlueBackground rounded-md">
//         <Col className="salary-offer__parent-col" span={12}>
//           <Row className="salary-offer__content-row salary-offer__content-row--last">
//             {/* Current-Cols */}
//             <Col className="salary-offer__content-row__col" span={labelColSpan}>
//               <div className="salary-offer__content-row__field salary-offer__content-row__field--total">
//                 <label>Total Remuneration</label>
//               </div>
//             </Col>

//             <Col
//               className="salary-offer__content-row__col"
//               span={currencyColSpan}
//             >
//               <div className="salary-offer__content-row__field salary-offer__content-row__field--total">
//                 <Input
//                   readOnly
//                   value={formatNumberWithCommas(
//                     totalBenefitCurrent(
//                       offer_benefits?.current_total_bonus || 0
//                     ) || ""
//                   )}
//                   name="current_total_lti"
//                   placeholder="Value here..."
//                   size="large"
//                   type="text"
//                 />
//               </div>
//             </Col>

//             {currencyCode ? (
//               <Col className="salary-offer__content-row__col" span={7}>
//                 <div className="salary-offer__content-row__field salary-offer__content-row__field--total">
//                   <Input
//                     value={formatNumberWithCommas(
//                       round(
//                         totalBenefitCurrent(
//                           offer_benefits?.current_total_bonus || 0
//                         ) * currentCandidateCurrency!
//                       ) || ""
//                     )}
//                     readOnly
//                     placeholder="Value here..."
//                     size="large"
//                     type="text"
//                   />
//                 </div>
//               </Col>
//             ) : null}
//           </Row>
//         </Col>
//         <Col className="salary-offer__parent-col" span={12}>
//           <Row className="salary-offer__content-row salary-offer__content-row--last">
//             {/* Current-Cols */}
//             <Col className="salary-offer__content-row__col" span={labelColSpan}>
//               <div className="salary-offer__content-row__field salary-offer__content-row__field--total">
//                 <label>Total Remuneration</label>
//               </div>
//             </Col>

//             <Col
//               className="salary-offer__content-row__col"
//               span={currencyColSpan}
//             >
//               <div className="salary-offer__content-row__field salary-offer__content-row__field--total">
//                 <Input
//                   readOnly
//                   name="proposed_total_lti"
//                   value={formatNumberWithCommas(
//                     Math.round(totalBenefitProposed(proposedBenefitsValueTotal)) ||
//                     ""
//                   )}
//                   placeholder="Value here..."
//                   size="large"
//                   type="text"
//                 />
//               </div>
//             </Col>

//             {currencyCode ? (
//               <Col className="salary-offer__content-row__col" span={7}>
//                 <div className="salary-offer__content-row__field salary-offer__content-row__field--total">
//                   <Input
//                     value={formatNumberWithCommas(
//                       round(
//                         totalBenefitProposed(proposedBenefitsValueTotal) *
//                         currencyRate!
//                       ) || ""
//                     )}
//                     readOnly
//                     type="text"
//                     placeholder="Value here..."
//                     size="large"
//                   />
//                 </div>
//               </Col>
//             ) : null}
//           </Row>
//         </Col>
//       </Row>

//       <Row className="salary-offer">
//         <Col className="salary-offer__parent-col" span={12}>
//           <Row className="salary-offer__content-row salary-offer__content-row--last">
//             {/* Current-Cols */}
//             <Col className="salary-offer__content-row__col" span={labelColSpan}>
//               <div className="salary-offer__content-row__field salary-offer__content-row__field--total"></div>
//             </Col>

//             <Col
//               className="salary-offer__content-row__col"
//               span={currencyCode ? 14 : currencyColSpan}
//             >
//               <div className="salary-offer__content-row__field salary-offer__content-row__field--total"></div>
//             </Col>
//           </Row>
//         </Col>
//         <Col className="salary-offer__parent-col" span={12}>
//           <Row className="salary-offer__content-row salary-offer__content-row--last">
//             {/* Current-Cols */}
//             <Col className="salary-offer__content-row__col" span={labelColSpan}>
//               <div className="salary-offer__content-row__field salary-offer__content-row__field--total">
//                 <label>Remuneration Difference</label>
//               </div>
//             </Col>

//             <Col
//               className="salary-offer__content-row__col"
//               span={currencyCode ? 14 : currencyColSpan}
//             >
//               <div className="salary-offer__content-row__field salary-offer__content-row__field--total">
//                 <div
//                   className={`w-full px-6   text-white shadow-md my-2 font-semibold text-center text-sm outline-none border border-themeInputBorder bg-revampBlue  py-2 rounded-md`}
//                 >
//                   {`${differenceTwo?.toFixed(2)}%`}
//                 </div>
//               </div>
//             </Col>
//           </Row>
//         </Col>
//       </Row>
//     </>
//   );
// };

// export default OfferBenefits;


// v2
// import { useDispatch } from "react-redux";
// import { Row, Col, Input } from "antd";
// import _ from "lodash";
// import { ReactComponent as PlusIcon } from "@assets/images/plus-with-bg.svg";
// import { useTypedSelector } from "@hooks";
// import { handleOfferModeller } from "@store/offers";
// import { calculatePercentageAmount, getCurrencyTotal, round } from "@utils";
// import { useEffect } from "react";
// import { useLocation } from "react-router-dom";
// import { useFetchOfferCurrencyRateQuery } from "@/services";
// import { formatNumberWithCommas } from "@/utils/formatNumberWithCommas";
// import { currenciesConverter, calculatePropose } from "@utils";

// const OfferBenefits = () => {
//   const dispatch = useDispatch();
//   const { search } = useLocation();
//   const isRevised = search === "?mode=revise";
//   const {
//     offerModeller: { offer_benefits, offer_lti, offer_sti, offer_fixed_cash },
//     currencyRate,
//     currencyName,
//     offer,
//     offer_annual,
//     currentCandidateCurrency,
//   } = useTypedSelector(state => state.offers);
//   // Stock-aware PROPOSED LTI total, aligned with LongTermIncentives.getLtiTotal()
//   const proposedLtiStockAware = (() => {
//     const base = Number(offer_lti?.proposed_total_lti) || 0;
//     const stock = Number((offer_lti as any)?.selected_stock_value) || 1;

//     // If other_ltis exist, replace any "unit === false" entries with amount = value * stock
//     const adjusted = (offer_lti?.other_ltis || [])
//       .filter((x: any) => !x?.is_current)
//       .reduce((sum: number, it: any) => {
//         const value = Number(it?.value) || 0;
//         if (!it?.unit && value) {
//           // proposed_total_lti likely included raw value; replace raw with stock*value
//           return sum - value + round(value * (stock || 1));
//         }
//         return sum;
//       }, base);

//     return round(adjusted || 0);
//   })();

//   // Proposed-only: sum all proposed (non-current) benefit lines
//   // const proposedBenefitsValueTotal = (offer_benefits?.bonuses || [])
//   //   .filter(b => !b?.is_current)
//   //   .reduce((sum, b) => sum + (Number(b?.value) || 0), 0);

//   const calculateBenefitValue = (benefit: any): number => {
//     const rawCte =
//       benefit?.benefit_value_or_cte ??
//       benefit?.value ??
//       benefit?.percentage ??
//       0;

//     const cte = Number(rawCte) || 0;
//     const calculationBasis = benefit?.calculation_basis;
//     console.log("kk", calculationBasis)

//     const annualBaseSalary =
//       Number(offer_fixed_cash?.proposed_annual_base) || 0;

//     const guaranteedCash =
//       Number(offer_fixed_cash?.proposed_total) || 0;

//     let calculatedBenefitValue = 0;

//     switch (calculationBasis) {
//       case "percent_basic":
//         calculatedBenefitValue = calculatePercentageAmount(
//           annualBaseSalary,
//           cte
//         );
//         break;

//       case "percent_guaranteed":
//       case "percent_actual":
//         calculatedBenefitValue = calculatePercentageAmount(
//           guaranteedCash,
//           cte
//         );
//         break;

//       case "multiple_of_weekly_basic":
//         calculatedBenefitValue = round(
//           (annualBaseSalary / 52) * cte
//         );
//         console.log(annualBaseSalary, cte, "hey")
//         break;

//       case "flat":
//       default:
//         calculatedBenefitValue = cte;
//         break;
//     }

//     console.group(
//       `[Benefit Calculation] ${benefit?.name || benefit?.id}`
//     );

//     console.log("Complete benefit:", benefit);
//     console.log("New benefit_value_or_cte:", benefit?.benefit_value_or_cte);
//     console.log("Legacy value:", benefit?.value);
//     console.log("Legacy percentage:", benefit?.percentage);
//     console.log("Final CTE used:", cte);
//     console.log("Calculation basis:", calculationBasis);
//     console.log("Annual base salary:", annualBaseSalary);
//     console.log("Guaranteed cash:", guaranteedCash);
//     console.log("Calculated benefit value:", calculatedBenefitValue);

//     console.groupEnd();

//     return calculatedBenefitValue;
//   };

//   const getBenefitTotalContribution = (benefit: any): number => {
//     const calculatedBenefitValue = calculateBenefitValue(benefit);

//     const rawBenefitLimit = benefit?.benefit_limit;

//     const hasValidBenefitLimit =
//       rawBenefitLimit !== null &&
//       rawBenefitLimit !== undefined &&
//       rawBenefitLimit !== "" &&
//       Number.isFinite(Number(rawBenefitLimit));

//     const benefitLimit = hasValidBenefitLimit
//       ? Number(rawBenefitLimit)
//       : null;

//     const totalContribution =
//       benefitLimit === null
//         ? calculatedBenefitValue
//         : Math.min(calculatedBenefitValue, benefitLimit);

//     console.group(
//       `[Benefit Limit] ${benefit?.name || benefit?.id}`
//     );

//     console.log("Calculated Benefit Value:", calculatedBenefitValue);
//     console.log("Raw Benefit Limit:", rawBenefitLimit);
//     console.log("Has Valid Benefit Limit:", hasValidBenefitLimit);
//     console.log("Normalized Benefit Limit:", benefitLimit);
//     console.log("Total Contribution:", totalContribution);

//     console.groupEnd();

//     return totalContribution;
//   };

//   const proposedBenefitsValueTotal = (offer_benefits?.bonuses || [])
//     .filter(
//       benefit =>
//         !benefit?.is_current &&
//         !benefit?.exclude_from_offer
//     )
//     .reduce(
//       (total, benefit) =>
//         total + getBenefitTotalContribution(benefit),
//       0
//     );

//   const proposedBenefitsRemunerationTotal =
//     (offer_benefits?.bonuses || [])
//       .filter(
//         benefit =>
//           !benefit?.is_current &&
//           !benefit?.exclude_from_offer
//       )
//       .reduce(
//         (total, benefit) =>
//           total + getBenefitTotalContribution(benefit),
//         0
//       );

//   const { company } = useTypedSelector(state => state.auth?.user!);
//   const { id: company_id } = company!;

//   const readOnly =
//     offer && offer?.status !== "DRAFTED" && !isRevised ? true : false;
//   const currencyCode = currencyName?.split("(")[1]?.replace(")", "") || "";

//   const { proposed_currency_total } = getCurrencyTotal(
//     offer_benefits,
//     currencyRate,
//     []
//   );
//   const { current_currency_total } = getCurrencyTotal(
//     offer_benefits,
//     currentCandidateCurrency,
//     []
//   );

//   const labelColSpan = currencyCode ? 10 : 12;
//   const currencyColSpan = currencyCode ? 7 : 12;

//   const addMoreLocally = (is_current: boolean) => {
//     const newCurrent = {
//       is_current,
//       value: null,
//       name: null,
//       id: +_.uniqueId(),
//       readonly: true,
//     };
//     dispatch(
//       handleOfferModeller({
//         key: "offer_benefits",
//         data: {
//           bonuses: [...offer_benefits.bonuses, newCurrent],
//         },
//       })
//     );
//   };

//   const handleChangeNewField = (
//     id: number,
//     value: number | string,
//     type: "name" | "benefit_value_or_cte"
//   ) => {
//     dispatch(
//       handleOfferModeller({
//         key: "offer_benefits",
//         data: {
//           bonuses: offer_benefits?.bonuses?.map(bonus =>
//             bonus?.id === id ? { ...bonus, [type]: value } : bonus
//           ) as any,
//         },
//       })
//     );
//   };

//   const handleChangeNewFieldForPurpose = (
//     id: number,
//     value: number | string,
//     type: "name" | "value",
//     calculation_basis?: string
//   ) => {
//     dispatch(
//       handleOfferModeller({
//         key: "offer_benefits",
//         data: {
//           bonuses: offer_benefits?.bonuses?.map(bonus =>
//             bonus?.id === id
//               ? { ...bonus, [type]: value, calculation_basis }
//               : bonus
//           ) as any,
//         },
//       })
//     );
//   };
//   const removeField = (id: number) => {
//     dispatch(
//       handleOfferModeller({
//         key: "offer_benefits",
//         data: {
//           bonuses: offer_benefits?.bonuses?.map(bonus =>
//             bonus?.id === id ? { ...bonus, readonly: false } : bonus
//           ) as any,
//         },
//       })
//     );
//   };

//   const removeBonus = (id: number) => {
//     dispatch(
//       handleOfferModeller({
//         key: "offer_benefits",
//         data: {
//           bonuses: offer_benefits?.bonuses?.filter(
//             bonus => bonus?.id !== id
//           ) as any,
//         },
//       })
//     );
//   };

//   // const proposedTotal =
//   //   (offer_fixed_cash?.proposed_total || 0) +
//   //   (offer_sti?.proposed_total_bonus || 0) +
//   //   (offer_lti?.proposed_total_lti || 0) +
//   //   (offer_benefits?.proposed_total_bonus || 0);
//   const proposedTotal =
//     (offer_fixed_cash?.proposed_total || 0) +
//     (offer_sti?.proposed_total_bonus || 0) +
//     proposedLtiStockAware +
//     proposedBenefitsValueTotal; // ← use computed proposed benefits

//   const currentTotal =
//     (offer_fixed_cash?.current_total || 0) +
//     (offer_sti?.current_bonus_target || 0) +
//     (offer_lti?.current_total_lti || 0) +
//     (offer_benefits?.current_total_bonus || 0);

//   let percentageDifference = 0;

//   if (proposedTotal > 0 && currentTotal > 0) {
//     percentageDifference = (proposedTotal / currentTotal - 1) * 100;
//   }

//   const finalPercentage =
//     percentageDifference > 0 ? percentageDifference.toFixed(0) : 0;

//   let totalBenefitProposed = (proposedBenefits: number) => {
//     const result =
//       offer_sti?.is_sale_incentive &&
//         offer_fixed_cash?.proposed_annual_base &&
//         offer_sti?.proposed_base_pay_percentage
//         ? round(
//           (offer_fixed_cash.proposed_annual_base *
//             ((offer_fixed_cash.proposed_annual_base *
//               (100 - offer_sti.proposed_base_pay_percentage)) /
//               100)) /
//           ((offer_fixed_cash.proposed_annual_base *
//             offer_sti.proposed_base_pay_percentage) /
//             100) -
//           offer_sti.proposed_base_pay_percentage
//         ) +
//         ((offer_sti?.proposed_total_bonus || 0) +
//           (offer_fixed_cash?.proposed_total || 0))
//         : (offer_sti?.proposed_total_bonus || 0) +
//         (offer_fixed_cash?.proposed_total || 0);

//     // ⬇️ Use stock-aware LTI here
//     return result + proposedBenefits + proposedLtiStockAware || 0;
//   };

//   let totalBenefitCurrent = proposedTotal => {
//     var result =
//       offer_fixed_cash?.current_total + offer_sti?.current_total_bonus;
//     return result + proposedTotal + offer_lti?.current_total_lti || 0;
//   };

//   const {
//     data: counrtyList,
//     error,
//     isLoading,
//     isFetching,
//     isSuccess,
//     isError,
//     refetch,
//   } = useFetchOfferCurrencyRateQuery(
//     {
//       code: offer?.offer_candidate_detail?.currency?.id,
//       company_id,
//       offer_id: offer?.id,
//     },
//     {
//       refetchOnMountOrArgChange: true,
//       skip: !offer?.offer_candidate_detail?.currency?.id,
//     }
//   );
//   const currentOne = offer_benefits?.current_total_bonus;
//   const proposedOne = proposedBenefitsValueTotal;
//   const currencyDiffOne = currenciesConverter(
//     counrtyList?.data?.result || 1,
//     proposedOne
//   );
//   const differenceOne = calculatePropose(currentOne, currencyDiffOne);

//   //     offer_benefits?.current_total_bonus
//   // proposedBenefitsValueTotal
//   const currentTwo = totalBenefitCurrent(offer_benefits?.current_total_bonus);
//   const proposedTwo = Math.round(totalBenefitProposed(proposedBenefitsValueTotal));
//   const currencyDiffTwo = currenciesConverter(
//     counrtyList?.data?.result || 1,
//     proposedTwo
//   );
//   const differenceTwo = calculatePropose(currentTwo, currencyDiffTwo);

//   useEffect(() => {
//     handleChangeNewField("value_curr", +32, "null");
//   }, []);

//   return (
//     <>
//       <Row className="salary-offer">
//         <Col className="salary-offer__parent-col" span={12}>
//           <Row className="salary-offer__header-row cursor-pointer rounded-l-md  bg-revampLightBlueBackground">
//             <Col span={12}>
//               <div className="sub-heading font-semibold text-lg">Current</div>
//             </Col>
//           </Row>

//           <Row className="salary-offer__content-row salary-offer__content-row--last mt-5">
//             {/* Current-Cols */}
//             <Col className="salary-offer__content-row__col" span={labelColSpan}>
//               <div className="salary-offer__content-row__field-upper"></div>
//               {offer_benefits?.bonuses
//                 ?.filter(({ is_current }) => is_current)
//                 ?.map(({ name, id, readonly }) => (
//                   <div
//                     key={id}
//                     className={` ${offer_annual
//                       ? "salary-offer__content-row__field"
//                       : "salary-offer__content-row__field_extra"
//                       } `}
//                   >
//                     {name?.length && !readonly! ? (
//                       <label>{name}</label>
//                     ) : (
//                       <Input
//                         readOnly={readOnly}
//                         autoFocus
//                         onChange={e =>
//                           handleChangeNewField(id!, e?.target?.value, "name")
//                         }
//                         onKeyDown={e => {
//                           if (e.key === "Enter") {
//                             removeField(id!);
//                           }
//                         }}
//                         value={name || ""}
//                         placeholder="Value here..."
//                         size="large"
//                       />
//                     )}
//                     {!readOnly && (
//                       <div
//                         className="salary-offer__content-row__field__remove"
//                         onClick={() => removeBonus(id!)}
//                       >
//                         <PlusIcon fill="#000" />
//                       </div>
//                     )}
//                   </div>
//                 ))}
//               {!readOnly ? (
//                 <div
//                   onClick={() => addMoreLocally(true)}
//                   className="salary-offer__content-row__field--add-more"
//                 >
//                   <PlusIcon fill="#FF9560" />
//                   <span>Add more</span>
//                 </div>
//               ) : (
//                 <div className="salary-offer__content-row__field--add-more" />
//               )}
//             </Col>
//             <Col
//               className="salary-offer__content-row__col"
//               span={currencyColSpan}
//             >
//               <div className="salary-offer__content-row__field-upper">
//                 {offer?.offer_candidate_detail?.currency?.code}
//               </div>
//               {offer_benefits?.bonuses
//                 ?.filter(({ is_current }) => is_current)
//                 ?.map(({ name, value, id }) => (
//                   <div
//                     key={id}
//                     className={` ${offer_annual
//                       ? "salary-offer__content-row__field"
//                       : "salary-offer__content-row__field_extra"
//                       } `}
//                   >
//                     <div className={`w-full ${!offer_annual && "mt-4"}`}>
//                       <Input
//                         readOnly={readOnly}
//                         name={name!}
//                         type="text"
//                         value={formatNumberWithCommas(value || "")}
//                         onChange={e =>
//                           handleChangeNewField(
//                             id!,
//                             +e.target.value.replace(/,/g, ""),
//                             "value"
//                           )
//                         }
//                         type="text"
//                         placeholder="Value here..."
//                         size="large"
//                       />

//                       {!offer_annual && (
//                         <p className="pl-1">
//                           Monthly:{" "}
//                           {formatNumberWithCommas(
//                             round(value ? value / 12 : 0)
//                           )}
//                         </p>
//                       )}
//                     </div>
//                   </div>
//                 ))}
//             </Col>
//             {currencyCode ? (
//               <Col className="salary-offer__content-row__col" span={7}>
//                 <div className="salary-offer__content-row__field-upper">
//                   {currencyCode}
//                 </div>
//                 {offer_benefits?.bonuses
//                   ?.filter(({ is_current }) => is_current)
//                   ?.map(({ id, value }) => (
//                     <div
//                       key={id}
//                       className={` ${offer_annual
//                         ? "salary-offer__content-row__field"
//                         : "salary-offer__content-row__field_extra"
//                         } `}
//                     >
//                       <div className={`w-full ${!offer_annual && "mt-4"}`}>
//                         <Input
//                           value={formatNumberWithCommas(
//                             round(value! * currentCandidateCurrency!) || ""
//                           )}
//                           readOnly
//                           placeholder="Value here..."
//                           size="large"
//                           type="text"
//                         />

//                         {!offer_annual && (
//                           <p className="pl-1">
//                             Monthly:{" "}
//                             {formatNumberWithCommas(
//                               round(
//                                 round(value! * currentCandidateCurrency!)
//                                   ? round(value! * currentCandidateCurrency!) /
//                                   12
//                                   : 0
//                               )
//                             )}
//                           </p>
//                         )}
//                       </div>
//                     </div>
//                   ))}
//               </Col>
//             ) : null}
//           </Row>
//         </Col>
//         <Col className="salary-offer__parent-col" span={12}>
//           <Row className="salary-offer__header-row cursor-pointer rounded-r-md bg-revampLightBlueBackground">
//             <Col span={12}>
//               <div className="sub-heading font-semibold text-lg">Proposed</div>
//             </Col>
//           </Row>
//           <Row className="salary-offer__content-row salary-offer__content-row--last mt-5">
//             {/* Proposed-Cols */}

//             <Col className="salary-offer__content-row__col" span={labelColSpan}>
//               <div className="salary-offer__content-row__field-upper"></div>

//               {offer_benefits?.bonuses
//                 ?.filter(({ is_current }) => !is_current)
//                 ?.map(
//                   ({
//                     name,
//                     id,
//                     readonly,
//                     benefit_entitlement,
//                   }) => (
//                     <div key={id}>
//                       <div
//                         className={`${offer_annual
//                           ? "salary-offer__content-row__field"
//                           : "salary-offer__content-row__field_extra"
//                           }`}
//                       >
//                         {name?.length && !readonly ? (
//                           <label>{name}</label>
//                         ) : (
//                           <Input
//                             readOnly={readOnly}
//                             autoFocus
//                             onChange={e =>
//                               handleChangeNewField(
//                                 id!,
//                                 e.target.value,
//                                 "name"
//                               )
//                             }
//                             onKeyDown={e => {
//                               if (e.key === "Enter") {
//                                 removeField(id!);
//                               }
//                             }}
//                             value={name || ""}
//                             placeholder="Value here..."
//                             size="large"
//                           />
//                         )}

//                         {!readOnly && (
//                           <div
//                             className="salary-offer__content-row__field__remove"
//                             onClick={() => removeBonus(id!)}
//                           >
//                             <PlusIcon fill="#000" />
//                           </div>
//                         )}
//                       </div>

//                       {benefit_entitlement && (
//                         <div
//                           style={{
//                             marginTop: "-20px",
//                             marginBottom: "12px",
//                             paddingLeft: "25px",
//                             paddingRight: "40px",
//                             fontSize: "11px",
//                             color: "#6B7280",
//                           }}
//                         >
//                           {benefit_entitlement}
//                         </div>
//                       )}
//                     </div>
//                   )
//                 )}

//               {!readOnly ? (
//                 <div
//                   onClick={() => addMoreLocally(false)}
//                   className="salary-offer__content-row__field--add-more"
//                 >
//                   <PlusIcon fill="#FF9560" />
//                   <span>Add more</span>
//                 </div>
//               ) : (
//                 <div className="salary-offer__content-row__field--add-more" />
//               )}


//             </Col>
//             <Col
//               className="salary-offer__content-row__col"
//               span={currencyColSpan}
//             >
//               <div className="salary-offer__content-row__field-upper">
//                 {offer?.offer_position_detail?.currency?.code}
//               </div>

//               {offer_benefits?.bonuses
//                 ?.filter(({ is_current }) => !is_current)
//                 ?.map((benefit: any) => {
//                   const {
//                     id,
//                     name,
//                     calculation_basis,
//                     benefit_value_or_cte,
//                   } = benefit;

//                   const calculatedBenefitValue = calculateBenefitValue(benefit);
//                   const totalContribution = getBenefitTotalContribution(benefit);

//                   console.log("[Benefit UI Display]", {
//                     id: benefit?.id,
//                     name: benefit?.name,
//                     calculationBasis: benefit?.calculation_basis,
//                     benefitValueOrCte: benefit?.benefit_value_or_cte,
//                     calculatedBenefitValue,
//                     benefitLimit: benefit?.benefit_limit,
//                     totalContribution,
//                   });

//                   return (
//                     <div
//                       key={id}
//                       className={`${offer_annual
//                         ? "salary-offer__content-row__field"
//                         : "salary-offer__content-row__field_extra"
//                         }`}
//                     >
//                       <div className={`w-full ${!offer_annual ? "mt-4" : ""}`}>
//                         <Input
//                           readOnly={
//                             readOnly ||
//                             calculation_basis === "percent_guaranteed" ||
//                             calculation_basis === "percent_actual" ||
//                             calculation_basis === "percent_basic" ||
//                             calculation_basis === "multiple_of_weekly_basic"
//                           }
//                           name={name}
//                           type="text"
//                           value={formatNumberWithCommas(totalContribution || "")}
//                           onChange={e =>
//                             handleChangeNewField(
//                               id,
//                               Number(e.target.value.replace(/,/g, "")),
//                               "benefit_value_or_cte"
//                             )
//                           }
//                           placeholder="Value here..."
//                           size="large"
//                         />

//                         {!offer_annual && (
//                           <p className="pl-1">
//                             Monthly:{" "}
//                             {formatNumberWithCommas(
//                               round(totalContribution / 12)
//                             )}
//                           </p>
//                         )}
//                       </div>
//                     </div>
//                   );
//                 })}
//             </Col>
//             {currencyCode ? (
//               <Col className="salary-offer__content-row__col" span={7}>
//                 <div className="salary-offer__content-row__field-upper">
//                   {currencyCode}
//                 </div>
//                 {offer_benefits?.bonuses
//                   ?.filter(({ is_current }) => !is_current)
//                   ?.map((benefit: any) => {
//                     const totalContribution = getBenefitTotalContribution(benefit);

//                     return (
//                       <div
//                         key={benefit.id}
//                         className={`${offer_annual
//                           ? "salary-offer__content-row__field"
//                           : "salary-offer__content-row__field_extra"
//                           }`}
//                       >
//                         <div className={`w-full ${!offer_annual ? "mt-4" : ""}`}>
//                           <Input
//                             value={formatNumberWithCommas(
//                               round(totalContribution * (currencyRate || 1)) || ""
//                             )}
//                             readOnly
//                             placeholder="Value here..."
//                             size="large"
//                             type="text"
//                           />

//                           {!offer_annual && (
//                             <p className="pl-1">
//                               Monthly:{" "}
//                               {formatNumberWithCommas(
//                                 round(
//                                   (totalContribution * (currencyRate || 1)) / 12
//                                 )
//                               )}
//                             </p>
//                           )}
//                         </div>
//                       </div>
//                     );
//                   })}
//               </Col>
//             ) : null}
//           </Row>
//         </Col>
//       </Row>

//       <Row className="salary-offer bg-revampLightBlueBackground rounded-md ">
//         <Col className="salary-offer__parent-col" span={12}>
//           <Row className="salary-offer__content-row salary-offer__content-row--last">
//             {/* Current-Cols */}
//             <Col className="salary-offer__content-row__col" span={labelColSpan}>
//               <div
//                 className={`${offer_annual
//                   ? "salary-offer__content-row__field  salary-offer__content-row__field--total"
//                   : "salary-offer__content-row__field_extra  salary-offer__content-row__field--total"
//                   } `}
//               >
//                 <label>Total Benefits</label>
//               </div>
//             </Col>

//             <Col
//               className="salary-offer__content-row__col"
//               span={currencyColSpan}
//             >
//               <div
//                 className={` ${offer_annual
//                   ? "salary-offer__content-row__field  salary-offer__content-row__field--total"
//                   : "salary-offer__content-row__field_extra  salary-offer__content-row__field--total"
//                   } `}
//               >
//                 <div className="w-full">
//                   <Input
//                     readOnly
//                     value={formatNumberWithCommas(
//                       offer_benefits?.current_total_bonus || ""
//                     )}
//                     name="current_total_lti"
//                     placeholder="Value here..."
//                     size="large"
//                     type="text"
//                   />

//                   {!offer_annual && (
//                     <p className="pl-1">
//                       Monthly:{" "}
//                       {formatNumberWithCommas(
//                         round(
//                           offer_benefits?.current_total_bonus
//                             ? offer_benefits?.current_total_bonus / 12
//                             : 0
//                         )
//                       )}
//                     </p>
//                   )}
//                 </div>
//               </div>
//             </Col>

//             {currencyCode ? (
//               <Col className="salary-offer__content-row__col" span={7}>
//                 <div
//                   className={` ${offer_annual
//                     ? "salary-offer__content-row__field  salary-offer__content-row__field--total"
//                     : "salary-offer__content-row__field_extra  salary-offer__content-row__field--total"
//                     } `}
//                 >
//                   <div className="w-full">
//                     <Input
//                       value={formatNumberWithCommas(
//                         current_currency_total || ""
//                       )}
//                       readOnly
//                       type="text"
//                       placeholder="Value here..."
//                       size="large"
//                     />

//                     {!offer_annual && (
//                       <p className="pl-1">
//                         Monthly:{" "}
//                         {formatNumberWithCommas(
//                           round(
//                             current_currency_total
//                               ? current_currency_total / 12
//                               : 0
//                           )
//                         )}
//                       </p>
//                     )}
//                   </div>
//                 </div>
//               </Col>
//             ) : null}
//           </Row>
//         </Col>
//         <Col className="salary-offer__parent-col" span={12}>
//           <Row className="salary-offer__content-row salary-offer__content-row--last">
//             {/* Current-Cols */}
//             <Col className="salary-offer__content-row__col " span={labelColSpan}>
//               <div
//                 className={`${offer_annual
//                   ? "salary-offer__content-row__field  salary-offer__content-row__field--total"
//                   : "salary-offer__content-row__field_extra  salary-offer__content-row__field--total"
//                   } `}
//               >
//                 <label>Total Benefits</label>
//               </div>
//             </Col>

//             <Col
//               className="salary-offer__content-row__col"
//               span={currencyColSpan}
//             >
//               <div
//                 className={` ${offer_annual
//                   ? "salary-offer__content-row__field  salary-offer__content-row__field--total"
//                   : "salary-offer__content-row__field_extra  salary-offer__content-row__field--total"
//                   } `}
//               >
//                 <div className="w-full">
//                   <Input
//                     readOnly
//                     type="text"
//                     name="proposed_total_lti"
//                     value={formatNumberWithCommas(proposedBenefitsValueTotal || "")}
//                     placeholder="Value here..."
//                     size="large"
//                   />

//                   {!offer_annual && (
//                     <p className="pl-1">
//                       Monthly:{" "}
//                       {formatNumberWithCommas(
//                         round(
//                           proposedBenefitsValueTotal ? proposedBenefitsValueTotal / 12 : 0
//                         )
//                       )}
//                     </p>
//                   )}
//                 </div>
//               </div>
//             </Col>

//             {currencyCode ? (
//               <Col className="salary-offer__content-row__col" span={7}>
//                 <div
//                   className={` ${offer_annual
//                     ? "salary-offer__content-row__field  salary-offer__content-row__field--total"
//                     : "salary-offer__content-row__field_extra  salary-offer__content-row__field--total"
//                     } `}
//                 >
//                   <div className="w-full">
//                     <Input
//                       value={formatNumberWithCommas(
//                         proposed_currency_total || ""
//                       )}
//                       readOnly
//                       placeholder="Value here..."
//                       size="large"
//                       type="text"
//                     />

//                     {!offer_annual && (
//                       <p className="pl-1">
//                         Monthly:{" "}
//                         {formatNumberWithCommas(
//                           round(
//                             proposed_currency_total
//                               ? proposed_currency_total / 12
//                               : 0
//                           )
//                         )}
//                       </p>
//                     )}
//                   </div>
//                 </div>
//               </Col>
//             ) : null}
//           </Row>
//         </Col>
//       </Row>

//       <Row className="salary-offer">
//         <Col className="salary-offer__parent-col" span={12}>
//           <Row className="salary-offer__content-row salary-offer__content-row--last">
//             {/* Current-Cols */}
//             <Col className="salary-offer__content-row__col" span={labelColSpan}>
//               <div className="salary-offer__content-row__field salary-offer__content-row__field--total"></div>
//             </Col>

//             <Col
//               className="salary-offer__content-row__col"
//               span={currencyCode ? 14 : currencyColSpan}
//             >
//               <div className="salary-offer__content-row__field salary-offer__content-row__field--total"></div>
//             </Col>
//           </Row>
//         </Col>
//         <Col className="salary-offer__parent-col" span={12}>
//           <Row className="salary-offer__content-row salary-offer__content-row--last">
//             {/* Current-Cols */}
//             <Col className="salary-offer__content-row__col" span={labelColSpan}>
//               <div className="salary-offer__content-row__field salary-offer__content-row__field--total">
//                 <label>Total Benefits Difference</label>
//               </div>
//             </Col>

//             <Col
//               className="salary-offer__content-row__col"
//               span={currencyCode ? 14 : currencyColSpan}
//             >
//               <div className="salary-offer__content-row__field salary-offer__content-row__field--total">
//                 <div
//                   className={`w-full px-6   text-white shadow-md my-2 font-semibold text-center text-sm outline-none border border-themeInputBorder bg-revampBlue  py-2 rounded-md`}
//                 >
//                   {`${differenceOne?.toFixed(2)}%`}
//                 </div>
//               </div>
//             </Col>
//           </Row>
//         </Col>
//       </Row>

//       <Row className="salary-offer bg-revampLightBlueBackground rounded-md">
//         <Col className="salary-offer__parent-col" span={12}>
//           <Row className="salary-offer__content-row salary-offer__content-row--last">
//             {/* Current-Cols */}
//             <Col className="salary-offer__content-row__col" span={labelColSpan}>
//               <div className="salary-offer__content-row__field salary-offer__content-row__field--total">
//                 <label>Total Remuneration</label>
//               </div>
//             </Col>

//             <Col
//               className="salary-offer__content-row__col"
//               span={currencyColSpan}
//             >
//               <div className="salary-offer__content-row__field salary-offer__content-row__field--total">
//                 <Input
//                   readOnly
//                   value={formatNumberWithCommas(
//                     totalBenefitCurrent(
//                       offer_benefits?.current_total_bonus || 0
//                     ) || ""
//                   )}
//                   name="current_total_lti"
//                   placeholder="Value here..."
//                   size="large"
//                   type="text"
//                 />
//               </div>
//             </Col>

//             {currencyCode ? (
//               <Col className="salary-offer__content-row__col" span={7}>
//                 <div className="salary-offer__content-row__field salary-offer__content-row__field--total">
//                   <Input
//                     value={formatNumberWithCommas(
//                       round(
//                         totalBenefitCurrent(
//                           offer_benefits?.current_total_bonus || 0
//                         ) * currentCandidateCurrency!
//                       ) || ""
//                     )}
//                     readOnly
//                     placeholder="Value here..."
//                     size="large"
//                     type="text"
//                   />
//                 </div>
//               </Col>
//             ) : null}
//           </Row>
//         </Col>
//         <Col className="salary-offer__parent-col" span={12}>
//           <Row className="salary-offer__content-row salary-offer__content-row--last">
//             {/* Current-Cols */}
//             <Col className="salary-offer__content-row__col" span={labelColSpan}>
//               <div className="salary-offer__content-row__field salary-offer__content-row__field--total">
//                 <label>Total Remuneration</label>
//               </div>
//             </Col>

//             <Col
//               className="salary-offer__content-row__col"
//               span={currencyColSpan}
//             >
//               <div className="salary-offer__content-row__field salary-offer__content-row__field--total">
//                 <Input
//                   readOnly
//                   name="proposed_total_lti"
//                   value={formatNumberWithCommas(
//                     Math.round(totalBenefitProposed(proposedBenefitsValueTotal)) ||
//                     ""
//                   )}
//                   placeholder="Value here..."
//                   size="large"
//                   type="text"
//                 />
//               </div>
//             </Col>

//             {currencyCode ? (
//               <Col className="salary-offer__content-row__col" span={7}>
//                 <div className="salary-offer__content-row__field salary-offer__content-row__field--total">
//                   <Input
//                     value={formatNumberWithCommas(
//                       round(
//                         totalBenefitProposed(proposedBenefitsValueTotal) *
//                         currencyRate!
//                       ) || ""
//                     )}
//                     readOnly
//                     type="text"
//                     placeholder="Value here..."
//                     size="large"
//                   />
//                 </div>
//               </Col>
//             ) : null}
//           </Row>
//         </Col>
//       </Row>

//       <Row className="salary-offer">
//         <Col className="salary-offer__parent-col" span={12}>
//           <Row className="salary-offer__content-row salary-offer__content-row--last">
//             {/* Current-Cols */}
//             <Col className="salary-offer__content-row__col" span={labelColSpan}>
//               <div className="salary-offer__content-row__field salary-offer__content-row__field--total"></div>
//             </Col>

//             <Col
//               className="salary-offer__content-row__col"
//               span={currencyCode ? 14 : currencyColSpan}
//             >
//               <div className="salary-offer__content-row__field salary-offer__content-row__field--total"></div>
//             </Col>
//           </Row>
//         </Col>
//         <Col className="salary-offer__parent-col" span={12}>
//           <Row className="salary-offer__content-row salary-offer__content-row--last">
//             {/* Current-Cols */}
//             <Col className="salary-offer__content-row__col" span={labelColSpan}>
//               <div className="salary-offer__content-row__field salary-offer__content-row__field--total">
//                 <label>Remuneration Difference</label>
//               </div>
//             </Col>

//             <Col
//               className="salary-offer__content-row__col"
//               span={currencyCode ? 14 : currencyColSpan}
//             >
//               <div className="salary-offer__content-row__field salary-offer__content-row__field--total">
//                 <div
//                   className={`w-full px-6   text-white shadow-md my-2 font-semibold text-center text-sm outline-none border border-themeInputBorder bg-revampBlue  py-2 rounded-md`}
//                 >
//                   {`${differenceTwo?.toFixed(2)}%`}
//                 </div>
//               </div>
//             </Col>
//           </Row>
//         </Col>
//       </Row>
//     </>
//   );
// };

// export default OfferBenefits;


// v3
import { useDispatch } from "react-redux";
import { Row, Col, Input } from "antd";
import _ from "lodash";
import { ReactComponent as PlusIcon } from "@assets/images/plus-with-bg.svg";
import { useTypedSelector } from "@hooks";
import { handleOfferModeller } from "@store/offers";
import { calculatePercentageAmount, getCurrencyTotal, round } from "@utils";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useFetchOfferCurrencyRateQuery } from "@/services";
import { formatNumberWithCommas } from "@/utils/formatNumberWithCommas";
import { currenciesConverter, calculatePropose } from "@utils";

const OfferBenefits = () => {
  const dispatch = useDispatch();
  const { search } = useLocation();
  const isRevised = search === "?mode=revise";
  const {
    offerModeller: { offer_benefits, offer_lti, offer_sti, offer_fixed_cash },
    currencyRate,
    currencyName,
    offer,
    offer_annual,
    currentCandidateCurrency,
  } = useTypedSelector(state => state.offers);
  // Stock-aware PROPOSED LTI total, aligned with LongTermIncentives.getLtiTotal()
  const proposedLtiStockAware = (() => {
    const base = Number(offer_lti?.proposed_total_lti) || 0;
    const stock = Number((offer_lti as any)?.selected_stock_value) || 1;

    // If other_ltis exist, replace any "unit === false" entries with amount = value * stock
    const adjusted = (offer_lti?.other_ltis || [])
      .filter((x: any) => !x?.is_current)
      .reduce((sum: number, it: any) => {
        const value = Number(it?.value) || 0;
        if (!it?.unit && value) {
          // proposed_total_lti likely included raw value; replace raw with stock*value
          return sum - value + round(value * (stock || 1));
        }
        return sum;
      }, base);

    return round(adjusted || 0);
  })();

  // Proposed-only: sum all proposed (non-current) benefit lines
  // const proposedBenefitsValueTotal = (offer_benefits?.bonuses || [])
  //   .filter(b => !b?.is_current)
  //   .reduce((sum, b) => sum + (Number(b?.value) || 0), 0);

  const calculateBenefitValue = (benefit: any): number => {
    // Custom-detail benefits are informational only and must not affect totals.
    if (benefit?.show_custom_detail) {
      return 0;
    }

    const rawCte =
      benefit?.benefit_value_or_cte ??
      benefit?.value ??
      benefit?.percentage ??
      0;

    const cte = Number(rawCte) || 0;
    const calculationBasis = benefit?.calculation_basis;
    console.log("kk", calculationBasis)

    const annualBaseSalary =
      Number(offer_fixed_cash?.proposed_annual_base) || 0;

    const guaranteedCash =
      Number(offer_fixed_cash?.proposed_total) || 0;

    let calculatedBenefitValue = 0;

    switch (calculationBasis) {
      case "percent_basic":
        calculatedBenefitValue = calculatePercentageAmount(
          annualBaseSalary,
          cte
        );
        break;

      case "percent_guaranteed":
      case "percent_actual":
        calculatedBenefitValue = calculatePercentageAmount(
          guaranteedCash,
          cte
        );
        break;

      case "multiple_of_weekly_basic":
        calculatedBenefitValue = round(
          (annualBaseSalary / 52) * cte
        );
        console.log(annualBaseSalary, cte, "hey")
        break;

      case "flat":
      default:
        calculatedBenefitValue = cte;
        break;
    }

    console.group(
      `[Benefit Calculation] ${benefit?.name || benefit?.id}`
    );

    console.log("Complete benefit:", benefit);
    console.log("New benefit_value_or_cte:", benefit?.benefit_value_or_cte);
    console.log("Legacy value:", benefit?.value);
    console.log("Legacy percentage:", benefit?.percentage);
    console.log("Final CTE used:", cte);
    console.log("Calculation basis:", calculationBasis);
    console.log("Annual base salary:", annualBaseSalary);
    console.log("Guaranteed cash:", guaranteedCash);
    console.log("Calculated benefit value:", calculatedBenefitValue);

    console.groupEnd();

    return calculatedBenefitValue;
  };

  const getBenefitTotalContribution = (benefit: any): number => {
    const calculatedBenefitValue = calculateBenefitValue(benefit);

    // const rawBenefitLimit = benefit?.benefit_limit;

    // const hasValidBenefitLimit =
    //   rawBenefitLimit !== null &&
    //   rawBenefitLimit !== undefined &&
    //   rawBenefitLimit !== "" &&
    //   Number.isFinite(Number(rawBenefitLimit));

    // const benefitLimit = hasValidBenefitLimit
    //   ? Number(rawBenefitLimit)
    //   : null;

    // const totalContribution =
    //   benefitLimit === null
    //     ? calculatedBenefitValue
    //     : Math.min(calculatedBenefitValue, benefitLimit);

    const rawBenefitLimit = benefit?.benefit_limit;

    const hasValidBenefitLimit =
      rawBenefitLimit !== null &&
      rawBenefitLimit !== undefined &&
      rawBenefitLimit !== "" &&
      Number.isFinite(Number(rawBenefitLimit)) &&
      Number(rawBenefitLimit) > 0; // Ignore 0

    const benefitLimit = hasValidBenefitLimit
      ? Number(rawBenefitLimit)
      : null;

    const totalContribution =
      benefitLimit === null
        ? calculatedBenefitValue
        : Math.min(calculatedBenefitValue, benefitLimit);

    console.group(
      `[Benefit Limit] ${benefit?.name || benefit?.id}`
    );

    console.log("Calculated Benefit Value:", calculatedBenefitValue);
    console.log("Raw Benefit Limit:", rawBenefitLimit);
    console.log("Has Valid Benefit Limit:", hasValidBenefitLimit);
    console.log("Normalized Benefit Limit:", benefitLimit);
    console.log("Total Contribution:", totalContribution);

    console.groupEnd();

    return totalContribution;
  };

  const proposedBenefitsValueTotal = (offer_benefits?.bonuses || [])
    .filter(
      benefit =>
        !benefit?.is_current &&
        !benefit?.exclude_from_offer
    )
    .reduce(
      (total, benefit) =>
        total + getBenefitTotalContribution(benefit),
      0
    );

  // Total remuneration includes every proposed benefit, even when
  // exclude_from_offer is true. That flag only excludes it from Total Benefits.
  const proposedBenefitsRemunerationTotal =
    (offer_benefits?.bonuses || [])
      .filter(benefit => !benefit?.is_current)
      .reduce(
        (total, benefit) =>
          total + getBenefitTotalContribution(benefit),
        0
      );

  const { company } = useTypedSelector(state => state.auth?.user!);
  const { id: company_id } = company!;

  const readOnly =
    offer && offer?.status !== "DRAFTED" && !isRevised ? true : false;
  const currencyCode = currencyName?.split("(")[1]?.replace(")", "") || "";

  const proposedCurrencyTotal = round(
    proposedBenefitsValueTotal * (currencyRate || 1)
  );
  const { current_currency_total } = getCurrencyTotal(
    offer_benefits,
    currentCandidateCurrency,
    []
  );

  const labelColSpan = currencyCode ? 10 : 12;
  const currencyColSpan = currencyCode ? 7 : 12;

  const addMoreLocally = (is_current: boolean) => {
    const newCurrent = {
      is_current,
      value: null,
      name: null,
      id: +_.uniqueId(),
      readonly: true,
    };
    dispatch(
      handleOfferModeller({
        key: "offer_benefits",
        data: {
          bonuses: [...offer_benefits.bonuses, newCurrent],
        },
      })
    );
  };

  const handleChangeNewField = (
    id: number,
    value: number | string,
    type: "name" | "benefit_value_or_cte"
  ) => {
    dispatch(
      handleOfferModeller({
        key: "offer_benefits",
        data: {
          bonuses: offer_benefits?.bonuses?.map(bonus =>
            bonus?.id === id ? { ...bonus, [type]: value } : bonus
          ) as any,
        },
      })
    );
  };

  const handleChangeNewFieldForPurpose = (
    id: number,
    value: number | string,
    type: "name" | "value",
    calculation_basis?: string
  ) => {
    dispatch(
      handleOfferModeller({
        key: "offer_benefits",
        data: {
          bonuses: offer_benefits?.bonuses?.map(bonus =>
            bonus?.id === id
              ? { ...bonus, [type]: value, calculation_basis }
              : bonus
          ) as any,
        },
      })
    );
  };
  const removeField = (id: number) => {
    dispatch(
      handleOfferModeller({
        key: "offer_benefits",
        data: {
          bonuses: offer_benefits?.bonuses?.map(bonus =>
            bonus?.id === id ? { ...bonus, readonly: false } : bonus
          ) as any,
        },
      })
    );
  };

  const removeBonus = (id: number) => {
    dispatch(
      handleOfferModeller({
        key: "offer_benefits",
        data: {
          bonuses: offer_benefits?.bonuses?.filter(
            bonus => bonus?.id !== id
          ) as any,
        },
      })
    );
  };

  // const proposedTotal =
  //   (offer_fixed_cash?.proposed_total || 0) +
  //   (offer_sti?.proposed_total_bonus || 0) +
  //   (offer_lti?.proposed_total_lti || 0) +
  //   (offer_benefits?.proposed_total_bonus || 0);
  const proposedTotal =
    (offer_fixed_cash?.proposed_total || 0) +
    (offer_sti?.proposed_total_bonus || 0) +
    proposedLtiStockAware +
    proposedBenefitsValueTotal; // ← use computed proposed benefits

  const currentTotal =
    (offer_fixed_cash?.current_total || 0) +
    (offer_sti?.current_bonus_target || 0) +
    (offer_lti?.current_total_lti || 0) +
    (offer_benefits?.current_total_bonus || 0);

  let percentageDifference = 0;

  if (proposedTotal > 0 && currentTotal > 0) {
    percentageDifference = (proposedTotal / currentTotal - 1) * 100;
  }

  const finalPercentage =
    percentageDifference > 0 ? percentageDifference.toFixed(0) : 0;

  let totalBenefitProposed = (proposedBenefits: number) => {
    const result =
      offer_sti?.is_sale_incentive &&
        offer_fixed_cash?.proposed_annual_base &&
        offer_sti?.proposed_base_pay_percentage
        ? round(
          (offer_fixed_cash.proposed_annual_base *
            ((offer_fixed_cash.proposed_annual_base *
              (100 - offer_sti.proposed_base_pay_percentage)) /
              100)) /
          ((offer_fixed_cash.proposed_annual_base *
            offer_sti.proposed_base_pay_percentage) /
            100) -
          offer_sti.proposed_base_pay_percentage
        ) +
        ((offer_sti?.proposed_total_bonus || 0) +
          (offer_fixed_cash?.proposed_total || 0))
        : (offer_sti?.proposed_total_bonus || 0) +
        (offer_fixed_cash?.proposed_total || 0);

    // ⬇️ Use stock-aware LTI here
    return result + proposedBenefits + proposedLtiStockAware || 0;
  };

  let totalBenefitCurrent = proposedTotal => {
    var result =
      offer_fixed_cash?.current_total + offer_sti?.current_total_bonus;
    return result + proposedTotal + offer_lti?.current_total_lti || 0;
  };

  const {
    data: counrtyList,
    error,
    isLoading,
    isFetching,
    isSuccess,
    isError,
    refetch,
  } = useFetchOfferCurrencyRateQuery(
    {
      code: offer?.offer_candidate_detail?.currency?.id,
      company_id,
      offer_id: offer?.id,
    },
    {
      refetchOnMountOrArgChange: true,
      skip: !offer?.offer_candidate_detail?.currency?.id,
    }
  );
  const currentOne = offer_benefits?.current_total_bonus;
  const proposedOne = proposedBenefitsValueTotal;
  const currencyDiffOne = currenciesConverter(
    counrtyList?.data?.result || 1,
    proposedOne
  );
  const differenceOne = calculatePropose(currentOne, currencyDiffOne);

  //     offer_benefits?.current_total_bonus
  // proposedBenefitsValueTotal
  const currentTwo = totalBenefitCurrent(offer_benefits?.current_total_bonus);
  const proposedTwo = Math.round(
    totalBenefitProposed(proposedBenefitsRemunerationTotal)
  );
  const currencyDiffTwo = currenciesConverter(
    counrtyList?.data?.result || 1,
    proposedTwo
  );
  const differenceTwo = calculatePropose(currentTwo, currencyDiffTwo);

  useEffect(() => {
    handleChangeNewField("value_curr", +32, "null");
  }, []);

  return (
    <>
      <Row className="salary-offer">
        <Col className="salary-offer__parent-col" span={12}>
          <Row className="salary-offer__header-row cursor-pointer rounded-l-md  bg-revampLightBlueBackground">
            <Col span={12}>
              <div className="sub-heading font-semibold text-lg">Current</div>
            </Col>
          </Row>

          <Row className="salary-offer__content-row salary-offer__content-row--last mt-5">
            {/* Current-Cols */}
            <Col className="salary-offer__content-row__col" span={labelColSpan}>
              <div className="salary-offer__content-row__field-upper"></div>
              {offer_benefits?.bonuses
                ?.filter(({ is_current }) => is_current)
                ?.map(({ name, id, readonly }) => (
                  <div
                    key={id}
                    className={` ${offer_annual
                      ? "salary-offer__content-row__field"
                      : "salary-offer__content-row__field_extra"
                      } `}
                  >
                    {name?.length && !readonly! ? (
                      <label>{name}</label>
                    ) : (
                      <Input
                        readOnly={readOnly}
                        autoFocus
                        onChange={e =>
                          handleChangeNewField(id!, e?.target?.value, "name")
                        }
                        onKeyDown={e => {
                          if (e.key === "Enter") {
                            removeField(id!);
                          }
                        }}
                        value={name || ""}
                        placeholder="Value here..."
                        size="large"
                      />
                    )}
                    {!readOnly && (
                      <div
                        className="salary-offer__content-row__field__remove"
                        onClick={() => removeBonus(id!)}
                      >
                        <PlusIcon fill="#000" />
                      </div>
                    )}
                  </div>
                ))}
              {!readOnly ? (
                <div
                  onClick={() => addMoreLocally(true)}
                  className="salary-offer__content-row__field--add-more"
                >
                  <PlusIcon fill="#FF9560" />
                  <span>Add more</span>
                </div>
              ) : (
                <div className="salary-offer__content-row__field--add-more" />
              )}
            </Col>
            <Col
              className="salary-offer__content-row__col"
              span={currencyColSpan}
            >
              <div className="salary-offer__content-row__field-upper">
                {offer?.offer_candidate_detail?.currency?.code}
              </div>
              {offer_benefits?.bonuses
                ?.filter(({ is_current }) => is_current)
                ?.map(({ name, value, id }) => (
                  <div
                    key={id}
                    className={` ${offer_annual
                      ? "salary-offer__content-row__field"
                      : "salary-offer__content-row__field_extra"
                      } `}
                  >
                    <div className={`w-full ${!offer_annual && "mt-4"}`}>
                      <Input
                        readOnly={readOnly}
                        name={name!}
                        type="text"
                        value={formatNumberWithCommas(value || "")}
                        onChange={e =>
                          handleChangeNewField(
                            id!,
                            +e.target.value.replace(/,/g, ""),
                            "value"
                          )
                        }
                        type="text"
                        placeholder="Value here..."
                        size="large"
                      />

                      {!offer_annual && (
                        <p className="pl-1">
                          Monthly:{" "}
                          {formatNumberWithCommas(
                            round(value ? value / 12 : 0)
                          )}
                        </p>
                      )}
                    </div>
                  </div>
                ))}
            </Col>
            {currencyCode ? (
              <Col className="salary-offer__content-row__col" span={7}>
                <div className="salary-offer__content-row__field-upper">
                  {currencyCode}
                </div>
                {offer_benefits?.bonuses
                  ?.filter(({ is_current }) => is_current)
                  ?.map(({ id, value }) => (
                    <div
                      key={id}
                      className={` ${offer_annual
                        ? "salary-offer__content-row__field"
                        : "salary-offer__content-row__field_extra"
                        } `}
                    >
                      <div className={`w-full ${!offer_annual && "mt-4"}`}>
                        <Input
                          value={formatNumberWithCommas(
                            round(value! * currentCandidateCurrency!) || ""
                          )}
                          readOnly
                          placeholder="Value here..."
                          size="large"
                          type="text"
                        />

                        {!offer_annual && (
                          <p className="pl-1">
                            Monthly:{" "}
                            {formatNumberWithCommas(
                              round(
                                round(value! * currentCandidateCurrency!)
                                  ? round(value! * currentCandidateCurrency!) /
                                  12
                                  : 0
                              )
                            )}
                          </p>
                        )}
                      </div>
                    </div>
                  ))}
              </Col>
            ) : null}
          </Row>
        </Col>
        <Col className="salary-offer__parent-col" span={12}>
          <Row className="salary-offer__header-row cursor-pointer rounded-r-md bg-revampLightBlueBackground">
            <Col span={12}>
              <div className="sub-heading font-semibold text-lg">Proposed</div>
            </Col>
          </Row>
          <Row className="salary-offer__content-row salary-offer__content-row--last mt-5">
            {/* Proposed-Cols */}

            <Col className="salary-offer__content-row__col" span={labelColSpan}>
              <div className="salary-offer__content-row__field-upper"></div>

              {offer_benefits?.bonuses
                ?.filter(({ is_current }) => !is_current)
                ?.map((benefit: any) => {
                  const {
                    name,
                    id,
                    readonly,
                    benefit_entitlement,
                    show_custom_detail,
                    custom_detail,
                  } = benefit;

                  return (
                    <div key={id}>
                      <div
                        className={`${offer_annual
                          ? "salary-offer__content-row__field"
                          : "salary-offer__content-row__field_extra"
                          }`}
                      >
                        {show_custom_detail ? (
                          <label>{custom_detail || ""}</label>
                        ) : name?.length && !readonly ? (
                          <label>{name}</label>
                        ) : (
                          <Input
                            readOnly={readOnly}
                            autoFocus
                            onChange={e =>
                              handleChangeNewField(
                                id!,
                                e.target.value,
                                "name"
                              )
                            }
                            onKeyDown={e => {
                              if (e.key === "Enter") {
                                removeField(id!);
                              }
                            }}
                            value={name || ""}
                            placeholder="Value here..."
                            size="large"
                          />
                        )}

                        {!readOnly && (
                          <div
                            className="salary-offer__content-row__field__remove"
                            onClick={() => removeBonus(id!)}
                          >
                            <PlusIcon fill="#000" />
                          </div>
                        )}
                      </div>

                      {!show_custom_detail && benefit_entitlement && (
                        <div
                          style={{
                            marginTop: "-20px",
                            marginBottom: "3px",
                            paddingLeft: "25px",
                            paddingRight: "40px",
                            fontSize: "11px",
                            color: "#6B7280",
                          }}
                        >
                          {benefit_entitlement}
                        </div>
                      )}
                    </div>
                  );
                })}

              {!readOnly ? (
                <div
                  onClick={() => addMoreLocally(false)}
                  className="salary-offer__content-row__field--add-more"
                >
                  <PlusIcon fill="#FF9560" />
                  <span>Add more</span>
                </div>
              ) : (
                <div className="salary-offer__content-row__field--add-more" />
              )}


            </Col>
            <Col
              className="salary-offer__content-row__col"
              span={currencyColSpan}
            >
              <div className="salary-offer__content-row__field-upper">
                {offer?.offer_position_detail?.currency?.code}
              </div>

              {offer_benefits?.bonuses
                ?.filter(({ is_current }) => !is_current)
                ?.map((benefit: any) => {
                  const {
                    id,
                    name,
                    calculation_basis,
                    benefit_value_or_cte,
                    show_custom_detail,
                  } = benefit;

                  const calculatedBenefitValue = calculateBenefitValue(benefit);
                  const totalContribution = getBenefitTotalContribution(benefit);

                  console.log("[Benefit UI Display]", {
                    id: benefit?.id,
                    name: benefit?.name,
                    calculationBasis: benefit?.calculation_basis,
                    benefitValueOrCte: benefit?.benefit_value_or_cte,
                    calculatedBenefitValue,
                    benefitLimit: benefit?.benefit_limit,
                    totalContribution,
                  });

                  if (show_custom_detail) {
                    return (
                      <div
                        key={id}
                        className={`${offer_annual
                          ? "salary-offer__content-row__field"
                          : "salary-offer__content-row__field_extra"
                          }`}
                      />
                    );
                  }

                  return (
                    <div
                      key={id}
                      className={`${offer_annual
                        ? "salary-offer__content-row__field"
                        : "salary-offer__content-row__field_extra"
                        }`}
                    >
                      <div className={`w-full ${!offer_annual ? "mt-4" : ""}`}>
                        <Input
                          readOnly={
                            readOnly ||
                            calculation_basis === "percent_guaranteed" ||
                            calculation_basis === "percent_actual" ||
                            calculation_basis === "percent_basic" ||
                            calculation_basis === "multiple_of_weekly_basic"
                          }
                          name={name}
                          type="text"
                          value={formatNumberWithCommas(totalContribution || "")}
                          onChange={e =>
                            handleChangeNewField(
                              id,
                              Number(e.target.value.replace(/,/g, "")),
                              "benefit_value_or_cte"
                            )
                          }
                          placeholder="Value here..."
                          size="large"
                        />

                        {!offer_annual && (
                          <p className="pl-1">
                            Monthly:{" "}
                            {formatNumberWithCommas(
                              round(totalContribution / 12)
                            )}
                          </p>
                        )}
                      </div>
                    </div>
                  );
                })}
            </Col>
            {currencyCode ? (
              <Col className="salary-offer__content-row__col" span={7}>
                <div className="salary-offer__content-row__field-upper">
                  {currencyCode}
                </div>
                {offer_benefits?.bonuses
                  ?.filter(({ is_current }) => !is_current)
                  ?.map((benefit: any) => {
                    const totalContribution = getBenefitTotalContribution(benefit);
                    const showCustomDetail = Boolean(benefit?.show_custom_detail);

                    if (showCustomDetail) {
                      return (
                        <div
                          key={benefit.id}
                          className={`${offer_annual
                            ? "salary-offer__content-row__field"
                            : "salary-offer__content-row__field_extra"
                            }`}
                        />
                      );
                    }

                    return (
                      <div
                        key={benefit.id}
                        className={`${offer_annual
                          ? "salary-offer__content-row__field"
                          : "salary-offer__content-row__field_extra"
                          }`}
                      >
                        <div className={`w-full ${!offer_annual ? "mt-4" : ""}`}>
                          <Input
                            value={formatNumberWithCommas(
                              round(
                                totalContribution * (currencyRate || 1)
                              ) || ""
                            )}
                            readOnly
                            placeholder="Value here..."
                            size="large"
                            type="text"
                          />

                          {!offer_annual && (
                            <p className="pl-1">
                              Monthly:{" "}
                              {formatNumberWithCommas(
                                round(
                                  (totalContribution * (currencyRate || 1)) / 12
                                )
                              )}
                            </p>
                          )}
                        </div>
                      </div>
                    );
                  })}
              </Col>
            ) : null}
          </Row>
        </Col>
      </Row>

      <Row className="salary-offer bg-revampLightBlueBackground rounded-md ">
        <Col className="salary-offer__parent-col" span={12}>
          <Row className="salary-offer__content-row salary-offer__content-row--last">
            {/* Current-Cols */}
            <Col className="salary-offer__content-row__col" span={labelColSpan}>
              <div
                className={`${offer_annual
                  ? "salary-offer__content-row__field  salary-offer__content-row__field--total"
                  : "salary-offer__content-row__field_extra  salary-offer__content-row__field--total"
                  } `}
              >
                <label>Total Benefits</label>
              </div>
            </Col>

            <Col
              className="salary-offer__content-row__col"
              span={currencyColSpan}
            >
              <div
                className={` ${offer_annual
                  ? "salary-offer__content-row__field  salary-offer__content-row__field--total"
                  : "salary-offer__content-row__field_extra  salary-offer__content-row__field--total"
                  } `}
              >
                <div className="w-full">
                  <Input
                    readOnly
                    value={formatNumberWithCommas(
                      offer_benefits?.current_total_bonus || ""
                    )}
                    name="current_total_lti"
                    placeholder="Value here..."
                    size="large"
                    type="text"
                  />

                  {!offer_annual && (
                    <p className="pl-1">
                      Monthly:{" "}
                      {formatNumberWithCommas(
                        round(
                          offer_benefits?.current_total_bonus
                            ? offer_benefits?.current_total_bonus / 12
                            : 0
                        )
                      )}
                    </p>
                  )}
                </div>
              </div>
            </Col>

            {currencyCode ? (
              <Col className="salary-offer__content-row__col" span={7}>
                <div
                  className={` ${offer_annual
                    ? "salary-offer__content-row__field  salary-offer__content-row__field--total"
                    : "salary-offer__content-row__field_extra  salary-offer__content-row__field--total"
                    } `}
                >
                  <div className="w-full">
                    <Input
                      value={formatNumberWithCommas(
                        current_currency_total || ""
                      )}
                      readOnly
                      type="text"
                      placeholder="Value here..."
                      size="large"
                    />

                    {!offer_annual && (
                      <p className="pl-1">
                        Monthly:{" "}
                        {formatNumberWithCommas(
                          round(
                            current_currency_total
                              ? current_currency_total / 12
                              : 0
                          )
                        )}
                      </p>
                    )}
                  </div>
                </div>
              </Col>
            ) : null}
          </Row>
        </Col>
        <Col className="salary-offer__parent-col" span={12}>
          <Row className="salary-offer__content-row salary-offer__content-row--last">
            {/* Current-Cols */}
            <Col className="salary-offer__content-row__col " span={labelColSpan}>
              <div
                className={`${offer_annual
                  ? "salary-offer__content-row__field  salary-offer__content-row__field--total"
                  : "salary-offer__content-row__field_extra  salary-offer__content-row__field--total"
                  } `}
              >
                <label>Total Benefits</label>
              </div>
            </Col>

            <Col
              className="salary-offer__content-row__col"
              span={currencyColSpan}
            >
              <div
                className={` ${offer_annual
                  ? "salary-offer__content-row__field  salary-offer__content-row__field--total"
                  : "salary-offer__content-row__field_extra  salary-offer__content-row__field--total"
                  } `}
              >
                <div className="w-full">
                  <Input
                    readOnly
                    type="text"
                    name="proposed_total_lti"
                    value={formatNumberWithCommas(proposedBenefitsValueTotal || "")}
                    placeholder="Value here..."
                    size="large"
                  />

                  {!offer_annual && (
                    <p className="pl-1">
                      Monthly:{" "}
                      {formatNumberWithCommas(
                        round(
                          proposedBenefitsValueTotal ? proposedBenefitsValueTotal / 12 : 0
                        )
                      )}
                    </p>
                  )}
                </div>
              </div>
            </Col>

            {currencyCode ? (
              <Col className="salary-offer__content-row__col" span={7}>
                <div
                  className={` ${offer_annual
                    ? "salary-offer__content-row__field  salary-offer__content-row__field--total"
                    : "salary-offer__content-row__field_extra  salary-offer__content-row__field--total"
                    } `}
                >
                  <div className="w-full">
                    <Input
                      value={formatNumberWithCommas(
                        proposedCurrencyTotal || ""
                      )}
                      readOnly
                      placeholder="Value here..."
                      size="large"
                      type="text"
                    />

                    {!offer_annual && (
                      <p className="pl-1">
                        Monthly:{" "}
                        {formatNumberWithCommas(
                          round(
                            proposedCurrencyTotal
                              ? proposedCurrencyTotal / 12
                              : 0
                          )
                        )}
                      </p>
                    )}
                  </div>
                </div>
              </Col>
            ) : null}
          </Row>
        </Col>
      </Row>

      <Row className="salary-offer">
        <Col className="salary-offer__parent-col" span={12}>
          <Row className="salary-offer__content-row salary-offer__content-row--last">
            {/* Current-Cols */}
            <Col className="salary-offer__content-row__col" span={labelColSpan}>
              <div className="salary-offer__content-row__field salary-offer__content-row__field--total"></div>
            </Col>

            <Col
              className="salary-offer__content-row__col"
              span={currencyCode ? 14 : currencyColSpan}
            >
              <div className="salary-offer__content-row__field salary-offer__content-row__field--total"></div>
            </Col>
          </Row>
        </Col>
        <Col className="salary-offer__parent-col" span={12}>
          <Row className="salary-offer__content-row salary-offer__content-row--last">
            {/* Current-Cols */}
            <Col className="salary-offer__content-row__col" span={labelColSpan}>
              <div className="salary-offer__content-row__field salary-offer__content-row__field--total">
                <label>Total Benefits Difference</label>
              </div>
            </Col>

            <Col
              className="salary-offer__content-row__col"
              span={currencyCode ? 14 : currencyColSpan}
            >
              <div className="salary-offer__content-row__field salary-offer__content-row__field--total">
                <div
                  className={`w-full px-6   text-white shadow-md my-2 font-semibold text-center text-sm outline-none border border-themeInputBorder bg-revampBlue  py-2 rounded-md`}
                >
                  {`${differenceOne?.toFixed(2)}%`}
                </div>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>

      <Row className="salary-offer bg-revampLightBlueBackground rounded-md">
        <Col className="salary-offer__parent-col" span={12}>
          <Row className="salary-offer__content-row salary-offer__content-row--last">
            {/* Current-Cols */}
            <Col className="salary-offer__content-row__col" span={labelColSpan}>
              <div className="salary-offer__content-row__field salary-offer__content-row__field--total">
                <label>Total Remuneration</label>
              </div>
            </Col>

            <Col
              className="salary-offer__content-row__col"
              span={currencyColSpan}
            >
              <div className="salary-offer__content-row__field salary-offer__content-row__field--total">
                <Input
                  readOnly
                  value={formatNumberWithCommas(
                    totalBenefitCurrent(
                      offer_benefits?.current_total_bonus || 0
                    ) || ""
                  )}
                  name="current_total_lti"
                  placeholder="Value here..."
                  size="large"
                  type="text"
                />
              </div>
            </Col>

            {currencyCode ? (
              <Col className="salary-offer__content-row__col" span={7}>
                <div className="salary-offer__content-row__field salary-offer__content-row__field--total">
                  <Input
                    value={formatNumberWithCommas(
                      round(
                        totalBenefitCurrent(
                          offer_benefits?.current_total_bonus || 0
                        ) * currentCandidateCurrency!
                      ) || ""
                    )}
                    readOnly
                    placeholder="Value here..."
                    size="large"
                    type="text"
                  />
                </div>
              </Col>
            ) : null}
          </Row>
        </Col>
        <Col className="salary-offer__parent-col" span={12}>
          <Row className="salary-offer__content-row salary-offer__content-row--last">
            {/* Current-Cols */}
            <Col className="salary-offer__content-row__col" span={labelColSpan}>
              <div className="salary-offer__content-row__field salary-offer__content-row__field--total">
                <label>Total Remuneration</label>
              </div>
            </Col>

            <Col
              className="salary-offer__content-row__col"
              span={currencyColSpan}
            >
              <div className="salary-offer__content-row__field salary-offer__content-row__field--total">
                <Input
                  readOnly
                  name="proposed_total_lti"
                  value={formatNumberWithCommas(
                    Math.round(
                      totalBenefitProposed(proposedBenefitsRemunerationTotal)
                    ) ||
                    ""
                  )}
                  placeholder="Value here..."
                  size="large"
                  type="text"
                />
              </div>
            </Col>

            {currencyCode ? (
              <Col className="salary-offer__content-row__col" span={7}>
                <div className="salary-offer__content-row__field salary-offer__content-row__field--total">
                  <Input
                    value={formatNumberWithCommas(
                      round(
                        totalBenefitProposed(proposedBenefitsRemunerationTotal) *
                        currencyRate!
                      ) || ""
                    )}
                    readOnly
                    type="text"
                    placeholder="Value here..."
                    size="large"
                  />
                </div>
              </Col>
            ) : null}
          </Row>
        </Col>
      </Row>

      <Row className="salary-offer">
        <Col className="salary-offer__parent-col" span={12}>
          <Row className="salary-offer__content-row salary-offer__content-row--last">
            {/* Current-Cols */}
            <Col className="salary-offer__content-row__col" span={labelColSpan}>
              <div className="salary-offer__content-row__field salary-offer__content-row__field--total"></div>
            </Col>

            <Col
              className="salary-offer__content-row__col"
              span={currencyCode ? 14 : currencyColSpan}
            >
              <div className="salary-offer__content-row__field salary-offer__content-row__field--total"></div>
            </Col>
          </Row>
        </Col>
        <Col className="salary-offer__parent-col" span={12}>
          <Row className="salary-offer__content-row salary-offer__content-row--last">
            {/* Current-Cols */}
            <Col className="salary-offer__content-row__col" span={labelColSpan}>
              <div className="salary-offer__content-row__field salary-offer__content-row__field--total">
                <label>Remuneration Difference</label>
              </div>
            </Col>

            <Col
              className="salary-offer__content-row__col"
              span={currencyCode ? 14 : currencyColSpan}
            >
              <div className="salary-offer__content-row__field salary-offer__content-row__field--total">
                <div
                  className={`w-full px-6   text-white shadow-md my-2 font-semibold text-center text-sm outline-none border border-themeInputBorder bg-revampBlue  py-2 rounded-md`}
                >
                  {`${differenceTwo?.toFixed(2)}%`}
                </div>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};

export default OfferBenefits;